import { z } from "zod";

export const tagSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  manual: z.boolean().optional(),
  automatic: z.boolean().optional(),
});
export type Tag = z.infer<typeof tagSchema>;
export const tagInputSchema = z.object({ name: z.string().trim().min(1, "Enter a tag name.") });
export const entityTagsInputSchema = z.object({ tagIds: z.array(z.uuid()) });
/** Multiple filters match any selected tag. Empty means no tag filter. */
export const tagFilterSchema = z
  .string()
  .refine(
    (value) => !value || value.split(",").every((id) => z.uuid().safeParse(id).success),
    "Invalid tag filter.",
  )
  .optional();
